import { format } from "date-fns";

export const NAVBAR_LINKS = [
  { link: "/", title: "About", to: "about" },
  { link: "/projects", title: "Projects", to: "projects", duration: 750 },
  { link: "/", title: "Skills", to: "skills", duration: 1250 },
  {
    link: "/experience",
    title: "Experience",
    to: "experience",
    duration: 1250,
  },
  { link: "/work", title: "Work", to: "work" },
  {
    link: "/achievements",
    title: "Achievements",
    to: "achievements",
    duration: 1250,
  },
  {
    link: "/testimonials",
    title: "Testimonials",
    to: "testimonial",
    duration: 1250,
  },
  { link: "/blogs", title: "Blogs", to: "blogs" },
  // { link: "/contact", title: "Contact", to: "contact" },
];

const allorders = [
  { order: 1, docId: "YBwzMixrSbxRu97ghdto", title: "The Crow Studio" },
  { order: 2, docId: "jeRAAYbRg1Zcbj00oYsd", title: "Asquare TechLab" },
  { order: 3, docId: "X09D0UsI8emqcmVNibRL", title: "Metaji – Tally Integration Tool"
  },
  { order: 4, docId: "31l4H9HomGyeezk3Cy0t", title: "Tic Tac Toe" },
  { order: 5, docId: "w81MAa82OIT4L4VF8Q14", title: "Weather Webapp" },
  {
    order: 6,
    docId: "IsyDu48oXwUN8hNAC2IB",
    title: "Oshop [ E-Commerce Website ]",
  },
];

const personalorders = [
  { order: 1, docId: "LWPJGoOJNFgo7HcR3z3m", title: "Netflix" },
  { order: 2, docId: "2KAxpW7fG27ZFh55sUSt", title: "Strike" },
  { order: 3, docId: "Bru0p0km0PzLO70tGGIM", title: "resort" },
  { order: 4, docId: "w81MAa82OIT4L4VF8Q14", title: "Weather Webapp" },
  { order: 5, docId: "31l4H9HomGyeezk3Cy0t", title: "Tic Tac Toe" },
  {
    order: 6,
    docId: "pcDwmcGopSEUJoLV1ngP",
    title: "Circle On A Elastic Bridge",
  },
];

const freelanceorders = [
  { order: 1, docId: "YBwzMixrSbxRu97ghdto", title: "The Crow Studio" },
  { order: 2, docId: "B2VCIP7fUaEWIl3LPqPo", title: "Solar" },
  { order: 3, docId: "jeRAAYbRg1Zcbj00oYsd", title: "Asquare TechLab" },
  { order: 4, docId: "22TfywgWqhJMOGFbOkHR", title: "Sigital farming" },
  { order: 5, docId: "zRJj6Njuy6da9p7ucGmp", title: "Raj Engineering" },
];

const blogorders = [
  { order: 1, docId: "5u1bTRUlSinHjdvlyL88" },
  { order: 2, docId: "Nt0Kz2IgaMDxd94FlpM9" },
  { order: 3, docId: "ffI69BWE4buas4VslvD3" },
  { order: 4, docId: "0b7W7TTYDt8jAXgiTzXz" },
  { order: 5, docId: "xHadR2jBLPOBf60ORbXQ" },
  { order: 6, docId: "LYWXMRjNODaeroxWEgsZ" },
];

export const sortBlogsBasedOnOrders = (blogs, isHome = false) => {
  let sortedBlogs = [];

  // for blogs page
  if (!isHome) {
    return blogs;
  }

  blogorders.map((order) => {
    let pro = blogs.find((pro) => pro?.blogId && pro.blogId === order.docId);
    sortedBlogs.push(pro);
  });

  return sortedBlogs;
};

export const sortProjectsBasedOnOrders = (
  projects,
  category,
  isHome = false
) => {
  let filteredProjects = [];
  let sortedProjects = [];

  if (category !== "all") {
    filteredProjects = projects.filter((pro) => pro.category === category);
  } else {
    filteredProjects = projects;
  }

  // for projects page
  if (!isHome) {
    return filteredProjects;
  }

  if (category === "personal") {
    personalorders.map((order) => {
      let pro = projects.find((pro) => pro?.proId && pro.proId === order.docId);
      sortedProjects.push(pro);
    });
  } else if (category === "freelance") {
    freelanceorders.map((order) => {
      let pro = projects.find((pro) => pro?.proId && pro.proId === order.docId);
      sortedProjects.push(pro);
    });
  } else {
    allorders.map((order) => {
      let pro = projects.find((pro) => pro?.proId && pro.proId === order.docId);
      sortedProjects.push(pro);
    });
  }

  return sortedProjects;
};

export const getActiveTab = (path) => {
  if (path === "/") return "Home";
  return NAVBAR_LINKS.find((item) => item.link === path).title;
};

export const getDuration = (start_date, end_date) => {
  const start =
    format(new Date(start_date), "MMMM") +
    ", " +
    format(new Date(start_date), "yyyy");
  let end = "Present";
  if (end_date?.length > 0) {
    end =
      format(new Date(end_date), "MMMM") +
      ", " +
      format(new Date(end_date), "yyyy");
  }
  let duration = `${start}  to  ${end}`;
  return duration;
};

export const getBlogCardStyles = (id) => {
  if (id % 2 === 1) {
    return {
      id: 0,
      borderColor: "#dee2e6",
      bgColor: "#242526",
      hoverColor: "",
      tagColor: "#fff",
      tagBgColor: "#343a40",
      textColor: "#ffffffe6",
    };
  }

  return {
    id: 1,
    borderColor: "#007bff",
    bgColor: "#242526",
    hoverColor: "",
    tagColor: "#fff",
    tagBgColor: "#007bff",
    textColor: "#ffffffe6",
  };
};

// return {
//   id: 2,
//   borderColor: "rgba(0,0,0,0.125)",
//   bgColor: "#17a2b8",
//   hoverColor: "#117a8b",
//   tagColor: "#343a40",
//   tagBgColor: "#f8f9fa",
//   textColor: "#fff",
// };
